import products from './products';

/**
 * Product families that do not require payment processing
 * These products are typically free or handled through different payment flows
 */
export const FAMILIES_NOT_REQUIRING_PAYMENT = [products.basic, products.breach, products.breachPlus];

export default {
  FAMILIES_NOT_REQUIRING_PAYMENT,
};
